export class Leads {
    id: string;
    firstName: string;
    lastName: string;
    dateSubmitted: Date;
    page: string;
    company: string;
    email: string;
    reason: string;
    industry: string;
    jobTitle: string;
    market: string;
    message: string;

    constructor() {
        this.id = '';
        this.firstName = '';
        this.lastName = '';
        this.dateSubmitted = null;
        this.page = '';
        this.company = '';
        this.reason = '';
        this.industry = '';
        this.email = '';
        this.jobTitle = '';
        this.market = '';
        this.message = '';
    }
}